!function (e) {
  var i = {};
  function a(n) {
    if (i[n]) return i[n].exports;
    var o = i[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, a), o.l = !0, o.exports;
  }
  a.m = e, a.c = i, a.d = function (e, i, n) {
    a.o(e, i) || Object.defineProperty(e, i, {
      enumerable: !0,
      get: n
    });
  }, a.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.t = function (e, i) {
    if (1 & i && (e = a(e)), 8 & i) return e;
    if (4 & i && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (a.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & i && "string" != typeof e) for (var o in e) a.d(n, o, function (i) {
      return e[i];
    }.bind(null, o));
    return n;
  }, a.n = function (e) {
    var i = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return a.d(i, "a", i), i;
  }, a.o = function (e, i) {
    return Object.prototype.hasOwnProperty.call(e, i);
  }, a.p = "", a(a.s = 0);
}([function (e, i, a) {
  "use strict";

  a.r(i);
  var n,
    o,
    t,
    s,
    l,
    r,
    d,
    m,
    y,
    p,
    N,
    c,
    f,
    O,
    u,
    A,
    S,
    C,
    g,
    E,
    _,
    I,
    L,
    T,
    w,
    D = function () {
      return !!("undefined" != typeof window && window.CBC && window.CBC.APP && window.CBC.APP.DMP && window.CBC.APP.DMP.LOTAME);
    };
  function h(e, i, a) {
    return i in e ? Object.defineProperty(e, i, {
      value: a,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[i] = a, e;
  }
  var k = {
      ARTS: "ARTS",
      AUTHENTICATED_USER: "AUTHENTICATED_USER",
      BOOKS: "BOOKS",
      CANADA_2017: "CANADA_2017",
      COMEDY: "COMEDY",
      COMMENTER: "COMMENTER",
      DEVICE_DESKTOP: "DEVICE_DESKTOP",
      DEVICE_MOBILE: "DEVICE_MOBILE",
      DEVICE_TABLET: "DEVICE_TABLET",
      DOCS: "DOCS",
      INTERNAL: "INTERNAL",
      LIFE: "LIFE",
      LISTEN: "LISTEN",
      LOCAL_BRITISH_COLUMBIA: "LOCAL_BRITISH_COLUMBIA",
      LOCAL_CALGARY: "LOCAL_CALGARY",
      LOCAL_EDMONTON: "LOCAL_EDMONTON",
      LOCAL_HAMILTON: "LOCAL_HAMILTON",
      LOCAL_KITCHENER_WATERLOO: "LOCAL_KITCHENER_WATERLOO",
      LOCAL_LONDON: "LOCAL_LONDON",
      LOCAL_MANITOBA: "LOCAL_MANITOBA",
      LOCAL_MONTREAL: "LOCAL_MONTREAL",
      LOCAL_NEWFOUNDLAND_LABRADOR: "LOCAL_NEWFOUNDLAND_LABRADOR",
      LOCAL_NEW_BRUNSWICK: "LOCAL_NEW_BRUNSWICK",
      LOCAL_NORTH: "LOCAL_NORTH",
      LOCAL_NOVA_SCOTIA: "LOCAL_NOVA_SCOTIA",
      LOCAL_OTTAWA: "LOCAL_OTTAWA",
      LOCAL_PEI: "LOCAL_PEI",
      LOCAL_SASKATCHEWAN: "LOCAL_SASKATCHEWAN",
      LOCAL_SASKATOON: "LOCAL_SASKATOON",
      LOCAL_SUDBURY: "LOCAL_SUDBURY",
      LOCAL_THUNDER_BAY: "LOCAL_THUNDER_BAY",
      LOCAL_TORONTO: "LOCAL_TORONTO",
      LOCAL_WINDSOR: "LOCAL_WINDSOR",
      MARKETPLACE: "MARKETPLACE",
      MUSIC: "MUSIC",
      NEWS: "NEWS",
      NEWS_BUSINESS: "NEWS_BUSINESS",
      NEWS_CANADA: "NEWS_CANADA",
      NEWS_ENTERTAINMENT: "NEWS_ENTERTAINMENT",
      NEWS_GO_PUBLIC: "NEWS_GO_PUBLIC",
      NEWS_HEALTH: "NEWS_HEALTH",
      NEWS_INDIGENOUS: "NEWS_INDIGENOUS",
      NEWS_INVESTIGATES: "NEWS_INVESTIGATES",
      NEWS_OPINION: "NEWS_OPINION",
      NEWS_POLITICS: "NEWS_POLITICS",
      NEWS_TECHNOLOGY: "NEWS_TECHNOLOGY",
      NEWS_WORLD: "NEWS_WORLD",
      PARALYMPICS: "PARALYMPICS",
      POWER_AND_POLITICS: "POWER_AND_POLITICS",
      RADIO: "RADIO",
      REFER_FACEBOOK: "REFER_FACEBOOK",
      REFER_GOOGLE: "REFER_GOOGLE",
      REFER_TWITTER: "REFER_TWITTER",
      SHOW_ALIAS_GRACE: "SHOW_ALIAS_GRACE",
      SHOW_ANNE: "SHOW_ANNE",
      SHOW_BECOMING_CANADIAN: "SHOW_BECOMING_CANADIAN",
      SHOW_BELLEVUE: "SHOW_BELLEVUE",
      SHOW_CANADA_READS: "SHOW_CANADA_READS",
      SHOW_CAUGHT: "SHOW_CAUGHT",
      SHOW_CORONATION_STREET: "SHOW_CORONATION_STREET",
      SHOW_EXHIBITIONISTS: "SHOW_EXHIBITIONISTS",
      SHOW_FIRSTHAND: "SHOW_FIRSTHAND",
      SHOW_FRAKE_DRAKE: "SHOW_FRAKE_DRAKE",
      SHOW_GREAT_BRITISH_BAKING_SHOW: "SHOW_GREAT_BRITISH_BAKING_SHOW",
      SHOW_GREAT_CANADIAN_BAKING_SHOW: "SHOW_GREAT_CANADIAN_BAKING_SHOW",
      SHOW_HEARTLAND: "SHOW_HEARTLAND",
      SHOW_KIMS_CONVENIENCE: "SHOW_KIMS_CONVENIENCE",
      SHOW_LAND_AND_SEA: "SHOW_LAND_AND_SEA",
      SHOW_MARKETPLACE: "SHOW_MARKETPLACE",
      SHOW_SCHITTS_CREEK: "SHOW_SCHITTS_CREEK",
      SHOW_THE_FIFTH_ESTATE: "SHOW_THE_FIFTH_ESTATE",
      SHOW_THE_GOODS: "SHOW_THE_GOODS",
      SHOW_THE_NATIONAL: "SHOW_THE_NATIONAL",
      SHOW_THE_NATURE_OF_THINGS: "SHOW_THE_NATURE_OF_THINGS",
      SPORTS: "SPORTS",
      THE_NATIONAL: "THE_NATIONAL",
      USER: "USER",
      WATCH_LIVE: "WATCH_LIVE"
    },
    M = "MEMBER",
    v = "LIGHT_USER",
    W = "HEAVY_USER",
    R = "MODERATE_USER",
    H = (h(w = {}, k.ARTS, {
      displayName: "Arts",
      category: "Sections",
      modifiers: (n = {}, h(n, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC Arts page at least once.",
        ranking: 1
      }), h(n, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 CBC Arts pages in the last week.",
        ranking: 5
      }), h(n, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 CBC Arts pages in the last week.",
        ranking: 10
      }), h(n, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 CBC Arts pages in the last week.",
        ranking: 20
      }), n),
      trendingSection: "arts",
      sectionPath: "arts",
      optInAllowed: !0
    }), h(w, k.AUTHENTICATED_USER, {
      displayName: "Authenticated user",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve logged into a CBC account at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.BOOKS, {
      displayName: "Books",
      category: "Sections",
      modifiers: (o = {}, h(o, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC Books page at least once.",
        ranking: 1
      }), h(o, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 CBC Books pages in the last week.",
        ranking: 5
      }), h(o, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 CBC Books pages in the last week.",
        ranking: 10
      }), h(o, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 CBC Books pages in the last week.",
        ranking: 20
      }), o),
      trendingSection: "books",
      sectionPath: "books",
      optInAllowed: !0
    }), h(w, k.CANADA_2017, {
      displayName: "Canada 2017",
      category: "Sections",
      modifiers: (t = {}, h(t, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any Canada 2017 page at least once.",
        ranking: 1
      }), h(t, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 Canada 2017 pages in the last week.",
        ranking: 5
      }), h(t, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 Canada 2017 pages in the last week.",
        ranking: 10
      }), h(t, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 Canada 2017 pages in the last week.",
        ranking: 20
      }), t),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.COMEDY, {
      displayName: "Comedy",
      category: "Sections",
      modifiers: (s = {}, h(s, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any Comedy page at least once.",
        ranking: 1
      }), h(s, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 Comedy pages in the last week.",
        ranking: 5
      }), h(s, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 Comedy pages in the last week.",
        ranking: 10
      }), h(s, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 Comedy pages in the last week.",
        ranking: 20
      }), s),
      trendingSection: "comedy",
      sectionPath: "comedy",
      optInAllowed: !0
    }), h(w, k.COMMENTER, {
      displayName: "Commenter",
      category: "Activity",
      modifiers: (l = {}, h(l, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You often comment on stories.",
        ranking: 16
      }), h(l, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've commented on stories a few times.",
        ranking: 2
      }), h(l, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've commented on stories several times.",
        ranking: 5
      }), h(l, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve commented on a story at least once.",
        ranking: 1
      }), l),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.DEVICE_DESKTOP, {
      displayName: "Desktop user",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited CBC from a desktop.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.DEVICE_MOBILE, {
      displayName: "Mobile user",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited CBC from a mobile device.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.DEVICE_TABLET, {
      displayName: "Tablet user",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited CBC from a tablet.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.DOCS, {
      displayName: "Documentaries",
      category: "Sections",
      modifiers: (r = {}, h(r, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any Documentaries page at least once.",
        ranking: 1
      }), h(r, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 Documentaries pages in the last week.",
        ranking: 5
      }), h(r, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 Documentaries pages in the last week.",
        ranking: 10
      }), h(r, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 Documentaries pages in the last week.",
        ranking: 20
      }), r),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.INTERNAL, {
      displayName: "Internal CBC user",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've visited internal Digital Products test/dev pages.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.LIFE, {
      displayName: "Life",
      category: "Sections",
      modifiers: (d = {}, h(d, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC Life page at least once.",
        ranking: 1
      }), h(d, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 CBC Life pages in the last week.",
        ranking: 5
      }), h(d, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 CBC Life pages in the last week.",
        ranking: 10
      }), h(d, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 CBC Life pages in the last week.",
        ranking: 20
      }), d),
      trendingSection: "lifestyle",
      sectionPath: "life",
      optInAllowed: !0
    }), h(w, k.LISTEN, {
      displayName: "Listen",
      category: "Sections",
      modifiers: (m = {}, h(m, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 pages on CBC Listen in the last week.",
        ranking: 5
      }), h(m, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 pages on CBC Listen in the last week.",
        ranking: 10
      }), h(m, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 pages on CBC Listen in the last week.",
        ranking: 20
      }), m),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.LOCAL_BRITISH_COLUMBIA, {
      displayName: "CBC British Columbia",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/british-columbia",
      optInAllowed: !0
    }), h(w, k.LOCAL_CALGARY, {
      displayName: "CBC Calgary",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/calgary",
      optInAllowed: !0
    }), h(w, k.LOCAL_EDMONTON, {
      displayName: "CBC Edmonton",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/edmonton",
      optInAllowed: !0
    }), h(w, k.LOCAL_HAMILTON, {
      displayName: "CBC Hamilton",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/hamilton",
      optInAllowed: !0
    }), h(w, k.LOCAL_KITCHENER_WATERLOO, {
      displayName: "CBC Kitchener-Waterloo",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/kitchener-waterloo",
      optInAllowed: !0
    }), h(w, k.LOCAL_LONDON, {
      displayName: "CBC London",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/london",
      optInAllowed: !0
    }), h(w, k.LOCAL_MANITOBA, {
      displayName: "CBC Manitoba",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/manitoba",
      optInAllowed: !0
    }), h(w, k.LOCAL_MONTREAL, {
      displayName: "CBC Montreal",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/montreal",
      optInAllowed: !0
    }), h(w, k.LOCAL_NEWFOUNDLAND_LABRADOR, {
      displayName: "CBC Newfoundland & Labrador",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/newfoundland-labrador",
      optInAllowed: !0
    }), h(w, k.LOCAL_NEW_BRUNSWICK, {
      displayName: "CBC New Brunswick",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/new-brunswick",
      optInAllowed: !0
    }), h(w, k.LOCAL_NORTH, {
      displayName: "CBC North",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/north",
      optInAllowed: !0
    }), h(w, k.LOCAL_NOVA_SCOTIA, {
      displayName: "CBC Nova Scotia",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/nova-scotia",
      optInAllowed: !0
    }), h(w, k.LOCAL_OTTAWA, {
      displayName: "CBC Ottawa",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/ottawa",
      optInAllowed: !0
    }), h(w, k.LOCAL_PEI, {
      displayName: "CBC Prince Edward Island",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/prince-edward-island",
      optInAllowed: !0
    }), h(w, k.LOCAL_SASKATCHEWAN, {
      displayName: "CBC Saskatchewan",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/saskatchewan",
      optInAllowed: !0
    }), h(w, k.LOCAL_SASKATOON, {
      displayName: "CBC Saskatoon",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/saskatoon",
      optInAllowed: !0
    }), h(w, k.LOCAL_SUDBURY, {
      displayName: "CBC Sudbury",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/sudbury",
      optInAllowed: !0
    }), h(w, k.LOCAL_THUNDER_BAY, {
      displayName: "CBC Thunder Bay",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/thunder-bay",
      optInAllowed: !0
    }), h(w, k.LOCAL_TORONTO, {
      displayName: "CBC Toronto",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/toronto",
      optInAllowed: !0
    }), h(w, k.LOCAL_WINDSOR, {
      displayName: "CBC Windsor",
      category: "Local CBC Centres",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: "news/canada/windsor",
      optInAllowed: !0
    }), h(w, k.MARKETPLACE, {
      displayName: "Marketplace",
      category: "News",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've visited a page from Marketplace at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.MUSIC, {
      displayName: "Music",
      category: "Sections",
      modifiers: (y = {}, h(y, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to the CBC Music site at least once.",
        ranking: 1
      }), h(y, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 pages on CBC Music in the last week.",
        ranking: 5
      }), h(y, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 pages on CBC Music in the last week.",
        ranking: 10
      }), h(y, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 pages on CBC Music in the last week.",
        ranking: 20
      }), y),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.NEWS, {
      displayName: "News",
      category: "Sections",
      modifiers: (p = {}, h(p, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC News page at least once.",
        ranking: 1
      }), h(p, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 news pages in the last week.",
        ranking: 5
      }), h(p, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 news pages in the last week.",
        ranking: 10
      }), h(p, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 news pages in the last week.",
        ranking: 20
      }), p),
      trendingSection: "news",
      sectionPath: "news",
      optInAllowed: !0
    }), h(w, k.NEWS_BUSINESS, {
      displayName: "Business News",
      category: "News",
      modifiers: (N = {}, h(N, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any business news page at least once.",
        ranking: 1
      }), h(N, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 business news pages in the last week.",
        ranking: 5
      }), h(N, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 business news pages in the last week.",
        ranking: 10
      }), h(N, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 business news pages in the last week.",
        ranking: 20
      }), N),
      trendingSection: "business",
      sectionPath: "news/business",
      optInAllowed: !0
    }), h(w, k.NEWS_CANADA, {
      displayName: "Canada News",
      category: "News",
      modifiers: (c = {}, h(c, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any page in the Canada section of news at least once.",
        ranking: 1
      }), h(c, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 pages in News Canada in the last week.",
        ranking: 5
      }), h(c, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 pages in News Canada in the last week.",
        ranking: 10
      }), h(c, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 pages in News Canada in the last week.",
        ranking: 20
      }), c),
      trendingSection: "canada",
      sectionPath: "news/canada",
      optInAllowed: !0
    }), h(w, k.NEWS_ENTERTAINMENT, {
      displayName: "Entertainment News",
      category: "News",
      modifiers: (f = {}, h(f, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any entertainment news page at least once.",
        ranking: 1
      }), h(f, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 entertainment news pages in the last week.",
        ranking: 5
      }), h(f, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 entertainment news pages in the last week.",
        ranking: 10
      }), h(f, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 entertainment news pages in the last week.",
        ranking: 20
      }), f),
      trendingSection: "entertainment",
      sectionPath: "news/entertainment",
      optInAllowed: !0
    }), h(w, k.NEWS_GO_PUBLIC, {
      displayName: "CBC's Go Public",
      category: "News",
      modifiers: (O = {}, h(O, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any page from CBC's Go Public series at least once.",
        ranking: 1
      }), h(O, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 pages from CBC's Go Public in the last week.",
        ranking: 5
      }), h(O, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 pages from CBC's Go Public in the last week.",
        ranking: 10
      }), h(O, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 pages from CBC's Go Public in the last week.",
        ranking: 20
      }), O),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.NEWS_HEALTH, {
      displayName: "Health News",
      category: "News",
      modifiers: (u = {}, h(u, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any health news page at least once.",
        ranking: 1
      }), h(u, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 health news pages in the last week.",
        ranking: 5
      }), h(u, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 health news pages in the last week.",
        ranking: 10
      }), h(u, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 health news pages in the last week.",
        ranking: 20
      }), u),
      trendingSection: "health",
      sectionPath: "news/health",
      optInAllowed: !0
    }), h(w, k.NEWS_INDIGENOUS, {
      displayName: "Indigenous News",
      category: "News",
      modifiers: (A = {}, h(A, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any news page in the Indigenous section at least once.",
        ranking: 1
      }), h(A, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 news pages in the Indigenous section in the last week.",
        ranking: 5
      }), h(A, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 news pages in the Indigenous section in the last week.",
        ranking: 10
      }), h(A, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 news pages in the Indigenous section in the last week.",
        ranking: 20
      }), A),
      trendingSection: "aboriginal",
      sectionPath: "news/indigenous",
      optInAllowed: !0
    }), h(w, k.NEWS_INVESTIGATES, {
      displayName: "CBC News Investigates",
      category: "News",
      modifiers: (S = {}, h(S, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any page within CBC News Investigates at least once.",
        ranking: 1
      }), h(S, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 news pages within CBC News Investigates in the last week.",
        ranking: 5
      }), h(S, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 news pages within CBC News Investigates in the last week.",
        ranking: 10
      }), h(S, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 news pages within CBC News Investigates in the last week.",
        ranking: 20
      }), S),
      trendingSection: "investigates",
      sectionPath: "news/investigates",
      optInAllowed: !0
    }), h(w, k.NEWS_OPINION, {
      displayName: "Opinion",
      category: "News",
      modifiers: (C = {}, h(C, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any opinion news page at least once.",
        ranking: 1
      }), h(C, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 opinion news pages in the last week.",
        ranking: 5
      }), h(C, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 opinion news pages in the last week.",
        ranking: 10
      }), h(C, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 opinion news pages in the last week.",
        ranking: 20
      }), C),
      trendingSection: "opinion",
      sectionPath: "news/opinion",
      optInAllowed: !0
    }), h(w, k.NEWS_POLITICS, {
      displayName: "Political News",
      category: "News",
      modifiers: (g = {}, h(g, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any politics news page at least once.",
        ranking: 1
      }), h(g, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 politics news pages in the last week.",
        ranking: 5
      }), h(g, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 politics news pages in the last week.",
        ranking: 10
      }), h(g, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 politics news pages in the last week.",
        ranking: 20
      }), g),
      trendingSection: "politics",
      sectionPath: "news/politics",
      optInAllowed: !0
    }), h(w, k.NEWS_TECHNOLOGY, {
      displayName: "Science News",
      category: "News",
      modifiers: (E = {}, h(E, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any science news page at least once.",
        ranking: 1
      }), h(E, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 science news pages in the last week.",
        ranking: 5
      }), h(E, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 science news pages in the last week.",
        ranking: 10
      }), h(E, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 science news pages in the last week.",
        ranking: 20
      }), E),
      trendingSection: "science",
      sectionPath: "news/science",
      optInAllowed: !0
    }), h(w, k.NEWS_WORLD, {
      displayName: "World News",
      category: "News",
      modifiers: (_ = {}, h(_, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any world news page at least once.",
        ranking: 1
      }), h(_, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 world news pages in the last week.",
        ranking: 5
      }), h(_, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 world news pages in the last week.",
        ranking: 10
      }), h(_, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 world news pages in the last week.",
        ranking: 20
      }), _),
      trendingSection: "world",
      sectionPath: "news/world",
      optInAllowed: !0
    }), h(w, k.PARALYMPICS, {
      displayName: "Paralympics",
      category: "Sections",
      modifiers: (I = {}, h(I, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've visited at least 3 Paralympics pages in the last month.",
        ranking: 3
      }), h(I, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited Paralympics pages at least once.",
        ranking: 1
      }), I),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.POWER_AND_POLITICS, {
      displayName: "Power & Politics",
      category: "News",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited a page from Power and Politics at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.RADIO, {
      displayName: "Radio",
      category: "Sections",
      modifiers: (L = {}, h(L, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC Radio page at least once.",
        ranking: 1
      }), h(L, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 CBC Radio pages in the last week.",
        ranking: 5
      }), h(L, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 CBC Radio pages in the last week.",
        ranking: 10
      }), h(L, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 CBC Radio pages in the last week.",
        ranking: 20
      }), L),
      trendingSection: "radio",
      sectionPath: "radio",
      optInAllowed: !0
    }), h(w, k.REFER_FACEBOOK, {
      displayName: "Facebook visitor",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve come to CBC from a Facebook link at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.REFER_GOOGLE, {
      displayName: "Google visitor",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve come to CBC from a Google search at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.REFER_TWITTER, {
      displayName: "Twitter visitor",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve come to CBC from a Twitter link at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.SHOW_ALIAS_GRACE, {
      displayName: "Alias Grace",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Alias Grace in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_ANNE, {
      displayName: "Anne",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Anne in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_BECOMING_CANADIAN, {
      displayName: "Becoming Canadian",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Becoming Canadian in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_BELLEVUE, {
      displayName: "Bellevue",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Bellevue in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_CANADA_READS, {
      displayName: "Canada Reads",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Canada Reads in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_CAUGHT, {
      displayName: "Caught",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Caught in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_CORONATION_STREET, {
      displayName: "Coronation Street",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Coronation Street in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_EXHIBITIONISTS, {
      displayName: "CBC Arts: Exhibitionists",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Exhibitionists in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_FIRSTHAND, {
      displayName: "Firsthand",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Firsthand in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_FRAKE_DRAKE, {
      displayName: "Frankie Drake Mysteries",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Frankie Drake Mysteries in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_GREAT_BRITISH_BAKING_SHOW, {
      displayName: "The Great British Baking Show",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The Great British Baking Show in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_GREAT_CANADIAN_BAKING_SHOW, {
      displayName: "The Great Canadian Baking Show",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The Great Canadian Baking Show in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_HEARTLAND, {
      displayName: "Heartland",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Heartland in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_KIMS_CONVENIENCE, {
      displayName: "Kim's Convenience",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Kim’s Convenience in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_LAND_AND_SEA, {
      displayName: "Land and Sea",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Land and Sea in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_MARKETPLACE, {
      displayName: "Marketplace",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Marketplace in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_SCHITTS_CREEK, {
      displayName: "Schitt's Creek",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from Schitt’s Creek in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_THE_FIFTH_ESTATE, {
      displayName: "The Fifth Estate",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The Fifth Estate in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_THE_GOODS, {
      displayName: "The Goods",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The Goods in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_THE_NATIONAL, {
      displayName: "The National",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The National in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SHOW_THE_NATURE_OF_THINGS, {
      displayName: "The Nature of Things",
      category: "Shows",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve looked at 3 or more pieces of content from The Nature of Things in the last month",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.SPORTS, {
      displayName: "Sports",
      category: "Sections",
      modifiers: (T = {}, h(T, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to any CBC Sports page at least once.",
        ranking: 1
      }), h(T, v, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 5 CBC Sports pages in the last week.",
        ranking: 5
      }), h(T, R, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 10 CBC Sports pages in the last week.",
        ranking: 10
      }), h(T, W, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've been to at least 20 CBC Sports pages in the last week.",
        ranking: 20
      }), T),
      trendingSection: "sports",
      sectionPath: "sports",
      optInAllowed: !0
    }), h(w, k.THE_NATIONAL, {
      displayName: "The National",
      category: "News",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've visited a page from The National at least once.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !0
    }), h(w, k.USER, {
      displayName: "CBC visitor",
      category: "Activity",
      modifiers: h({}, "LOVER_1MO", {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You’ve visited CBC many times in the last months.",
        ranking: 7
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), h(w, k.WATCH_LIVE, {
      displayName: "Watch Live",
      category: "Activity",
      modifiers: h({}, M, {
        displayName: "",
        useModifierDisplayNameOnly: !1,
        description: "You've visited a live TV stream.",
        ranking: 1
      }),
      trendingSection: null,
      sectionPath: null,
      optInAllowed: !1
    }), w),
    B = {
      295045: {
        family: k.DEVICE_MOBILE,
        modifier: M
      },
      295046: {
        family: k.DEVICE_TABLET,
        modifier: M
      },
      295047: {
        family: k.DEVICE_DESKTOP,
        modifier: M
      },
      317058: {
        family: k.DOCS,
        modifier: M
      },
      317088: {
        family: k.NEWS,
        modifier: M
      },
      318830: {
        family: k.LIFE,
        modifier: M
      },
      318831: {
        family: k.MUSIC,
        modifier: M
      },
      318833: {
        family: k.RADIO,
        modifier: M
      },
      318835: {
        family: k.SPORTS,
        modifier: M
      },
      318836: {
        family: k.ARTS,
        modifier: M
      },
      329462: {
        family: k.REFER_FACEBOOK,
        modifier: M
      },
      329464: {
        family: k.REFER_GOOGLE,
        modifier: M
      },
      329465: {
        family: k.REFER_TWITTER,
        modifier: M
      },
      331746: {
        family: k.INTERNAL,
        modifier: M
      },
      339250: {
        family: k.COMEDY,
        modifier: M
      },
      339251: {
        family: k.BOOKS,
        modifier: M
      },
      339255: {
        family: k.CANADA_2017,
        modifier: M
      },
      345023: {
        family: k.NEWS_BUSINESS,
        modifier: M
      },
      345024: {
        family: k.NEWS_CANADA,
        modifier: M
      },
      345025: {
        family: k.NEWS_ENTERTAINMENT,
        modifier: M
      },
      345026: {
        family: k.NEWS_HEALTH,
        modifier: M
      },
      345027: {
        family: k.NEWS_INDIGENOUS,
        modifier: M
      },
      345028: {
        family: k.NEWS_INVESTIGATES,
        modifier: M
      },
      345029: {
        family: k.NEWS_OPINION,
        modifier: M
      },
      345030: {
        family: k.NEWS_POLITICS,
        modifier: M
      },
      345031: {
        family: k.NEWS_TECHNOLOGY,
        modifier: M
      },
      345032: {
        family: k.NEWS_WORLD,
        modifier: M
      },
      345060: {
        family: k.MARKETPLACE,
        modifier: M
      },
      345062: {
        family: k.POWER_AND_POLITICS,
        modifier: M
      },
      345072: {
        family: k.THE_NATIONAL,
        modifier: M
      },
      356740: {
        family: null,
        modifier: M
      },
      356742: {
        family: null,
        modifier: M
      },
      356743: {
        family: null,
        modifier: M
      },
      356744: {
        family: null,
        modifier: M
      },
      356746: {
        family: null,
        modifier: M
      },
      356748: {
        family: null,
        modifier: M
      },
      357898: {
        family: k.CANADA_2017,
        modifier: v
      },
      357899: {
        family: k.CANADA_2017,
        modifier: R
      },
      357901: {
        family: k.CANADA_2017,
        modifier: W
      },
      357907: {
        family: k.DOCS,
        modifier: v
      },
      357909: {
        family: k.MUSIC,
        modifier: v
      },
      357920: {
        family: k.MUSIC,
        modifier: W
      },
      357931: {
        family: k.MUSIC,
        modifier: R
      },
      357933: {
        family: k.DOCS,
        modifier: R
      },
      357942: {
        family: k.DOCS,
        modifier: W
      },
      361516: {
        family: k.COMMENTER,
        modifier: M
      },
      361517: {
        family: k.COMMENTER,
        modifier: v
      },
      361518: {
        family: k.COMMENTER,
        modifier: R
      },
      361519: {
        family: k.COMMENTER,
        modifier: W
      },
      378238: {
        family: k.SHOW_EXHIBITIONISTS,
        modifier: M
      },
      378241: {
        family: k.SHOW_BECOMING_CANADIAN,
        modifier: M
      },
      378255: {
        family: k.SHOW_KIMS_CONVENIENCE,
        modifier: M
      },
      378258: {
        family: k.SHOW_SCHITTS_CREEK,
        modifier: M
      },
      378296: {
        family: k.SHOW_ALIAS_GRACE,
        modifier: M
      },
      378297: {
        family: k.SHOW_ANNE,
        modifier: M
      },
      378299: {
        family: k.SHOW_BELLEVUE,
        modifier: M
      },
      378300: {
        family: k.SHOW_CORONATION_STREET,
        modifier: M
      },
      378302: {
        family: k.SHOW_FRAKE_DRAKE,
        modifier: M
      },
      378304: {
        family: k.SHOW_HEARTLAND,
        modifier: M
      },
      378314: {
        family: k.SHOW_MARKETPLACE,
        modifier: M
      },
      378316: {
        family: k.SHOW_THE_NATIONAL,
        modifier: M
      },
      378317: {
        family: k.SHOW_THE_FIFTH_ESTATE,
        modifier: M
      },
      378319: {
        family: k.SHOW_LAND_AND_SEA,
        modifier: M
      },
      378320: {
        family: k.SHOW_THE_GOODS,
        modifier: M
      },
      378324: {
        family: k.SHOW_GREAT_BRITISH_BAKING_SHOW,
        modifier: M
      },
      378325: {
        family: k.SHOW_GREAT_CANADIAN_BAKING_SHOW,
        modifier: M
      },
      378357: {
        family: k.SHOW_CANADA_READS,
        modifier: M
      },
      378358: {
        family: k.SHOW_THE_NATURE_OF_THINGS,
        modifier: M
      },
      378363: {
        family: k.SHOW_FIRSTHAND,
        modifier: M
      },
      381689: {
        family: k.USER,
        modifier: "LOVER_1MO"
      },
      381942: {
        family: k.WATCH_LIVE,
        modifier: M
      },
      385784: {
        family: null,
        modifier: M
      },
      385946: {
        family: k.SPORTS,
        modifier: M
      },
      389994: {
        family: k.AUTHENTICATED_USER,
        modifier: M
      },
      390230: {
        family: k.SHOW_CAUGHT,
        modifier: M
      },
      392603: {
        family: k.NEWS_GO_PUBLIC,
        modifier: M
      },
      392681: {
        family: k.PARALYMPICS,
        modifier: M
      },
      392683: {
        family: k.PARALYMPICS,
        modifier: v
      },
      450457: {
        family: k.NEWS,
        modifier: v
      },
      450461: {
        family: k.NEWS,
        modifier: R
      },
      450463: {
        family: k.NEWS,
        modifier: W
      },
      450470: {
        family: k.ARTS,
        modifier: v
      },
      450472: {
        family: k.ARTS,
        modifier: R
      },
      450474: {
        family: k.ARTS,
        modifier: W
      },
      451112: {
        family: k.BOOKS,
        modifier: v
      },
      451113: {
        family: k.BOOKS,
        modifier: R
      },
      451116: {
        family: k.BOOKS,
        modifier: W
      },
      451377: {
        family: k.SPORTS,
        modifier: v
      },
      451378: {
        family: k.SPORTS,
        modifier: R
      },
      451379: {
        family: k.SPORTS,
        modifier: W
      },
      452136: {
        family: k.RADIO,
        modifier: v
      },
      452137: {
        family: k.RADIO,
        modifier: R
      },
      452138: {
        family: k.RADIO,
        modifier: W
      },
      452140: {
        family: k.NEWS_OPINION,
        modifier: v
      },
      452141: {
        family: k.NEWS_OPINION,
        modifier: R
      },
      452142: {
        family: k.NEWS_OPINION,
        modifier: W
      },
      453630: {
        family: k.COMEDY,
        modifier: v
      },
      453631: {
        family: k.COMEDY,
        modifier: R
      },
      453635: {
        family: k.COMEDY,
        modifier: W
      },
      453666: {
        family: k.LIFE,
        modifier: v
      },
      453667: {
        family: k.LIFE,
        modifier: R
      },
      453670: {
        family: k.LIFE,
        modifier: W
      },
      455160: {
        family: k.NEWS_BUSINESS,
        modifier: v
      },
      455162: {
        family: k.NEWS_BUSINESS,
        modifier: R
      },
      455164: {
        family: k.NEWS_BUSINESS,
        modifier: W
      },
      455166: {
        family: k.NEWS_POLITICS,
        modifier: v
      },
      455167: {
        family: k.NEWS_POLITICS,
        modifier: R
      },
      455168: {
        family: k.NEWS_POLITICS,
        modifier: W
      },
      455170: {
        family: k.NEWS_HEALTH,
        modifier: v
      },
      455173: {
        family: k.NEWS_HEALTH,
        modifier: R
      },
      455174: {
        family: k.NEWS_HEALTH,
        modifier: W
      },
      455293: {
        family: k.NEWS_ENTERTAINMENT,
        modifier: v
      },
      455296: {
        family: k.NEWS_ENTERTAINMENT,
        modifier: R
      },
      455301: {
        family: k.NEWS_ENTERTAINMENT,
        modifier: W
      },
      458893: {
        family: k.NEWS_CANADA,
        modifier: v
      },
      458894: {
        family: k.NEWS_CANADA,
        modifier: R
      },
      458895: {
        family: k.NEWS_CANADA,
        modifier: W
      },
      458897: {
        family: k.NEWS_WORLD,
        modifier: v
      },
      458898: {
        family: k.NEWS_WORLD,
        modifier: R
      },
      458899: {
        family: k.NEWS_WORLD,
        modifier: W
      },
      458900: {
        family: k.NEWS_INVESTIGATES,
        modifier: v
      },
      458931: {
        family: k.NEWS_INVESTIGATES,
        modifier: R
      },
      458935: {
        family: k.NEWS_INVESTIGATES,
        modifier: W
      },
      458936: {
        family: k.NEWS_INDIGENOUS,
        modifier: v
      },
      458937: {
        family: k.NEWS_INDIGENOUS,
        modifier: R
      },
      458938: {
        family: k.NEWS_INDIGENOUS,
        modifier: W
      },
      458940: {
        family: k.NEWS_TECHNOLOGY,
        modifier: v
      },
      458941: {
        family: k.NEWS_TECHNOLOGY,
        modifier: R
      },
      458942: {
        family: k.NEWS_TECHNOLOGY,
        modifier: W
      },
      783481: {
        family: k.LOCAL_BRITISH_COLUMBIA,
        modifier: M
      },
      783493: {
        family: k.LOCAL_CALGARY,
        modifier: M
      },
      789830: {
        family: k.LOCAL_EDMONTON,
        modifier: M
      },
      789831: {
        family: k.LOCAL_HAMILTON,
        modifier: M
      },
      789832: {
        family: k.LOCAL_KITCHENER_WATERLOO,
        modifier: M
      },
      789836: {
        family: k.LOCAL_LONDON,
        modifier: M
      },
      789838: {
        family: k.LOCAL_MANITOBA,
        modifier: M
      },
      789839: {
        family: k.LOCAL_MONTREAL,
        modifier: M
      },
      789851: {
        family: k.LOCAL_SASKATCHEWAN,
        modifier: M
      },
      789852: {
        family: k.LOCAL_SASKATOON,
        modifier: M
      },
      789853: {
        family: k.LOCAL_SUDBURY,
        modifier: M
      },
      789854: {
        family: k.LOCAL_THUNDER_BAY,
        modifier: M
      },
      789855: {
        family: k.LOCAL_TORONTO,
        modifier: M
      },
      789856: {
        family: k.LOCAL_WINDSOR,
        modifier: M
      },
      789857: {
        family: k.LOCAL_NEW_BRUNSWICK,
        modifier: M
      },
      789859: {
        family: k.LOCAL_NEWFOUNDLAND_LABRADOR,
        modifier: M
      },
      789861: {
        family: k.LOCAL_NORTH,
        modifier: M
      },
      789862: {
        family: k.LOCAL_NOVA_SCOTIA,
        modifier: M
      },
      789863: {
        family: k.LOCAL_OTTAWA,
        modifier: M
      },
      789864: {
        family: k.LOCAL_PEI,
        modifier: M
      }
    },
    P = {
      Sections: 0,
      News: 1,
      Shows: 2,
      Activity: 3,
      "Local CBC Centres": 4
    },
    Y = {
      248313: !0,
      248314: !0,
      290776: !0,
      290777: !0,
      290778: !0,
      294509: !0,
      294593: !0,
      294594: !0,
      294595: !0,
      294596: !0,
      294598: !0,
      294599: !0,
      294600: !0,
      301378: !0,
      341669: !0,
      359872: !0,
      359891: !0
    };
  function b(e, i) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, i) {
      var a = [],
        n = !0,
        o = !1,
        t = void 0;
      try {
        for (var s, l = e[Symbol.iterator](); !(n = (s = l.next()).done) && (a.push(s.value), !i || a.length !== i); n = !0);
      } catch (e) {
        o = !0, t = e;
      } finally {
        try {
          n || null == l.return || l.return();
        } finally {
          if (o) throw t;
        }
      }
      return a;
    }(e, i) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }
  var G = {
      LINEUP: 1,
      TRENDING: 2
    },
    U = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      if (Y[e.id]) return null;
      var i = {
        family: "",
        familyDisplayName: "",
        path: "",
        modifier: "",
        audienceDisplayName: e.id,
        description: "Sorry, we don't have a description available for this segment yet.",
        ranking: 0,
        id: e.id,
        trendingSection: null,
        category: ""
      };
      if (e.id in B) {
        var a = B[e.id].family;
        if (!a) return null;
        var n = B[e.id].modifier,
          o = H[a],
          t = J(o.modifiers[n].useModifierDisplayNameOnly, o.displayName, o.modifiers[n].displayName);
        i = Object.assign(i, {
          family: a,
          familyDisplayName: o.displayName,
          path: o.sectionPath,
          modifier: o.modifiers[n].displayName,
          audienceDisplayName: t,
          description: o.modifiers[n].description,
          ranking: o.modifiers[n].ranking,
          trendingSection: o.trendingSection,
          category: o.category
        });
      }
      return i;
    },
    K = function (e) {
      if (!H.hasOwnProperty(e)) return null;
      var i = H[e],
        a = Object.keys(i.modifiers).map(function (e) {
          return i.modifiers[e];
        }).reduce(function (e, i) {
          return i.ranking < e.ranking ? i : e;
        }),
        n = J(a.useModifierDisplayNameOnly, i.displayName, a.displayName);
      return {
        family: e,
        familyDisplayName: i.displayName,
        modifier: a.displayName,
        audienceDisplayName: n,
        description: a.description,
        ranking: a.ranking,
        trendingSection: i.trendingSection,
        category: i.category,
        path: i.sectionPath
      };
    },
    F = function (e) {
      var i = {},
        a = !0,
        n = !1,
        o = void 0;
      try {
        for (var t, s = e[Symbol.iterator](); !(a = (t = s.next()).done); a = !0) {
          var l = t.value;
          l.family in i && !(i[l.family].ranking < l.ranking) || (i[l.family] = l);
        }
      } catch (e) {
        n = !0, o = e;
      } finally {
        try {
          a || null == s.return || s.return();
        } finally {
          if (n) throw o;
        }
      }
      return i;
    },
    V = [[G.LINEUP, function (e) {
      return !(!e.sectionPath && !e.path);
    }], [G.TRENDING, function (e) {
      return !!e.trendingSection;
    }]],
    x = function (e, i) {
      return !!e && V.reduce(function (a, n) {
        var o = b(n, 2),
          t = o[0],
          s = o[1];
        return i & t && (a &= s(e)), a;
      }, !0);
    },
    j = function (e) {
      var i = F(e),
        a = [];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && a.push(Object.assign({}, i[n]));
      return a;
    },
    X = function (e, i) {
      var a = i.ranking - e.ranking;
      return 0 === a && (a = e.familyDisplayName.localeCompare(i.familyDisplayName)), a;
    },
    z = function (e, i) {
      return void 0 !== i && e.canOfferOptIn ? i : e.isInAudience;
    },
    q = function (e, i) {
      return e || i;
    },
    J = function (e, i, a) {
      var n = i;
      return e ? n = a : "" !== a && (n = i + " " + a), n;
    };
  exports.isLotameInitialized = D, exports.getActiveAudiences = function (e, i) {
    var a = F(e),
      n = [];
    for (var o in H) {
      var t = a[o];
      z({
        isInAudience: !!t,
        canOfferOptIn: q(!!t, H[o].optInAllowed)
      }, i.get(o)) && (t = t || K(o), n.push(t));
    }
    return n.sort(X), n;
  }, exports.getAvailableContentAudiences = function (e, i) {
    var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : G.TRENDING,
      n = {};
    j(e).forEach(function (e) {
      x(e, a) && (n[e.family] = e.id);
    }), 0 === Object.keys(n).length && (n[i] = -1);
    var o = {};
    for (var t in H) {
      var s = {},
        l = H[t];
      if (x(l, a)) {
        var r = n[t];
        s.family = t, s.trendingSection = l.trendingSection, s.sectionPath = l.sectionPath, s.label = l.displayName;
        var d = !!n[t];
        s.isInAudience = s.isInAudience || d, s.canOfferOptIn = q(s.isInAudience, l.optInAllowed), r >= 0 && (s.audienceId = r), s.canOfferOptIn && (o[t] = s);
      }
    }
    return o;
  }, exports.getAvailableAudiencesByCategory = function (e) {
    var i = j(e).reduce(function (e, i) {
        return e[i.family] = i, e;
      }, {}),
      a = {},
      n = function (e) {
        var n = i[e],
          o = !!n,
          t = H[e].category;
        if (!t || void 0 === P[t]) return "continue";
        var s = "",
          l = "";
        if (n) n.modifier && (s = n.modifier), l = n.audienceDisplayName;else {
          var r = Object.keys(H[e].modifiers).map(function (i) {
            return H[e].modifiers[i];
          }).reduce(function (e, i) {
            return i.ranking < e.ranking ? i : e;
          });
          s = r.displayName, l = J(r.useModifierDisplayNameOnly, H[e].displayName, s);
        }
        var d = a[t];
        d || (d = a[t] = {});
        var m = d[e];
        m || (m = d[e] = {}), m.category = t, m.family = e, m.displayName = l, m.isInAudience = o, m.canOfferOptIn = q(m.isInAudience, H[e].optInAllowed), n && (m.id = n.id);
      };
    for (var o in H) n(o);
    return a;
  }, exports.getAudienceCategories = function () {
    return Object.keys(P).sort(function (e, i) {
      return P[e] - P[i];
    });
  }, exports.getAudienceFamilies = function () {
    return Object.keys(H);
  }, exports.getFamilyDetails = function (e) {
    return H[e];
  }, exports.getDetailsForSegments = function (e) {
    return e.map(U).filter(Boolean);
  }, exports.shouldTreatAsInAudience = z, exports.FAMILY = k, exports.ContentSource = G, exports._test_audienceHierarchy = H, exports._test_audienceMapping = B;
}]);